import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BigNumber } from '@ethersproject/bignumber';
import { Percent, TradeType } from '@uniswap/sdk-core';
import { FeeAmount } from '@uniswap/v3-sdk';
import _ from 'lodash';
import { WRAPPED_NATIVE_CURRENCY } from '../../../..';
import { ChainId } from '../../../../util';
import { CurrencyAmount } from '../../../../util/amounts';
import { log } from '../../../../util/log';
import { buildSwapMethodParameters, buildTrade } from '../../../../util/methodParameters';
import { IV3GasModelFactory, usdGasTokensByChain } from '../gas-model';
import { BASE_SWAP_COST, COST_PER_HOP, COST_PER_INIT_TICK } from './gas-costs'; // Cost for crossing an uninitialized tick.

var COST_PER_UNINIT_TICK = BigNumber.from(0);
/**
 * Computes a gas estimate for a V3 swap using heuristics.
 * Considers number of hops in the route, number of ticks crossed
 * and the typical base cost for a swap.
 *
 * We get the number of ticks crossed in a swap from the QuoterV2
 * contract.
 *
 * We compute gas estimates off-chain because
 *  1/ Calling eth_estimateGas for a swaps requires the caller to have
 *     the full balance token being swapped, and approvals.
 *  2/ Tracking gas used using a wrapper contract is not accurate with Multicall
 *     due to EIP-2929. We would have to make a request for every swap we wanted to estimate.
 *  3/ For V2 we simulate all our swaps off-chain so have no way to track gas used.
 *
 * @export
 * @class V3HeuristicGasModelFactory
 */

export var V3HeuristicGasModelFactory = /*#__PURE__*/function (_IV3GasModelFactory) {
  _inherits(V3HeuristicGasModelFactory, _IV3GasModelFactory);

  var _super = _createSuper(V3HeuristicGasModelFactory);

  function V3HeuristicGasModelFactory() {
    _classCallCheck(this, V3HeuristicGasModelFactory);

    return _super.call(this);
  }

  _createClass(V3HeuristicGasModelFactory, [{
    key: "buildGasModel",
    value: function () {
      var _buildGasModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(chainId, gasPriceWei, poolProvider, token, l2GasDataProvider // this is the quoteToken
      ) {
        var _this = this;

        var l2GasData, usdPool, calculateL1GasFees, nativeCurrency, _estimateGasCost, nativePool, usdToken, estimateGasCost;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!l2GasDataProvider) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return l2GasDataProvider.getGasData();

              case 3:
                _context2.t0 = _context2.sent;
                _context2.next = 7;
                break;

              case 6:
                _context2.t0 = undefined;

              case 7:
                l2GasData = _context2.t0;
                _context2.next = 10;
                return this.getHighestLiquidityUSDPool(chainId, poolProvider);

              case 10:
                usdPool = _context2.sent;

                calculateL1GasFees = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(route) {
                    var swapOptions, l1Used, l1FeeInWei, _this$calculateOptimi, _this$calculateOptimi2, _this$calculateArbitr, _this$calculateArbitr2, nativeCurrency, costNativeCurrency, nativeTokenPrice, gasCostL1USD, gasCostL1QuoteToken, _nativePool, _nativeTokenPrice;

                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            swapOptions = {
                              recipient: '0x0000000000000000000000000000000000000001',
                              deadline: 100,
                              slippageTolerance: new Percent(5, 10000)
                            };
                            l1Used = BigNumber.from(0);
                            l1FeeInWei = BigNumber.from(0);

                            if (chainId == ChainId.OPTIMISM || chainId == ChainId.OPTIMISTIC_KOVAN) {
                              _this$calculateOptimi = _this.calculateOptimismToL1SecurityFee(route, swapOptions, l2GasData);
                              _this$calculateOptimi2 = _slicedToArray(_this$calculateOptimi, 2);
                              l1Used = _this$calculateOptimi2[0];
                              l1FeeInWei = _this$calculateOptimi2[1];
                            } else if (chainId == ChainId.ARBITRUM_ONE || chainId == ChainId.ARBITRUM_RINKEBY) {
                              _this$calculateArbitr = _this.calculateArbitrumToL1SecurityFee(route, swapOptions, l2GasData);
                              _this$calculateArbitr2 = _slicedToArray(_this$calculateArbitr, 2);
                              l1Used = _this$calculateArbitr2[0];
                              l1FeeInWei = _this$calculateArbitr2[1];
                            } // wrap fee to native currency


                            nativeCurrency = WRAPPED_NATIVE_CURRENCY[chainId];
                            costNativeCurrency = CurrencyAmount.fromRawAmount(nativeCurrency, l1FeeInWei.toString()); // convert fee into usd

                            nativeTokenPrice = usdPool.token0.address == nativeCurrency.address ? usdPool.token0Price : usdPool.token1Price;
                            gasCostL1USD = nativeTokenPrice.quote(costNativeCurrency);
                            gasCostL1QuoteToken = costNativeCurrency; // if the inputted token is not in the native currency, quote a native/quote token pool to get the gas cost in terms of the quote token

                            if (token.equals(nativeCurrency)) {
                              _context.next = 14;
                              break;
                            }

                            _context.next = 12;
                            return _this.getHighestLiquidityNativePool(chainId, token, poolProvider);

                          case 12:
                            _nativePool = _context.sent;

                            if (!_nativePool) {
                              log.info('Could not find a pool to convert the cost into the quote token');
                              gasCostL1QuoteToken = CurrencyAmount.fromRawAmount(token, 0);
                            } else {
                              _nativeTokenPrice = _nativePool.token0.address == nativeCurrency.address ? _nativePool.token0Price : _nativePool.token1Price;
                              gasCostL1QuoteToken = _nativeTokenPrice.quote(costNativeCurrency);
                            }

                          case 14:
                            return _context.abrupt("return", {
                              gasUsedL1: l1Used,
                              gasCostL1USD: gasCostL1USD,
                              gasCostL1QuoteToken: gasCostL1QuoteToken
                            });

                          case 15:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function calculateL1GasFees(_x6) {
                    return _ref.apply(this, arguments);
                  };
                }(); // If our quote token is WETH, we don't need to convert our gas use to be in terms
                // of the quote token in order to produce a gas adjusted amount.
                // We do return a gas use in USD however, so we still convert to usd.


                nativeCurrency = WRAPPED_NATIVE_CURRENCY[chainId];

                if (!token.equals(nativeCurrency)) {
                  _context2.next = 16;
                  break;
                }

                _estimateGasCost = function _estimateGasCost(routeWithValidQuote) {
                  var _this$estimateGas = _this.estimateGas(routeWithValidQuote, gasPriceWei, chainId),
                      totalGasCostNativeCurrency = _this$estimateGas.totalGasCostNativeCurrency,
                      baseGasUse = _this$estimateGas.baseGasUse;

                  var token0 = usdPool.token0.address == nativeCurrency.address;
                  var nativeTokenPrice = token0 ? usdPool.token0Price : usdPool.token1Price;
                  var gasCostInTermsOfUSD = nativeTokenPrice.quote(totalGasCostNativeCurrency);
                  return {
                    gasEstimate: baseGasUse,
                    gasCostInToken: totalGasCostNativeCurrency,
                    gasCostInUSD: gasCostInTermsOfUSD
                  };
                };

                return _context2.abrupt("return", {
                  estimateGasCost: _estimateGasCost,
                  calculateL1GasFees: calculateL1GasFees
                });

              case 16:
                _context2.next = 18;
                return this.getHighestLiquidityNativePool(chainId, token, poolProvider);

              case 18:
                nativePool = _context2.sent;
                usdToken = usdPool.token0.address == nativeCurrency.address ? usdPool.token1 : usdPool.token0;

                estimateGasCost = function estimateGasCost(routeWithValidQuote) {
                  var _this$estimateGas2 = _this.estimateGas(routeWithValidQuote, gasPriceWei, chainId),
                      totalGasCostNativeCurrency = _this$estimateGas2.totalGasCostNativeCurrency,
                      baseGasUse = _this$estimateGas2.baseGasUse;

                  if (!nativePool) {
                    log.info("Unable to find ".concat(nativeCurrency.symbol, " pool with the quote token, ").concat(token.symbol, " to produce gas adjusted costs. Route will not account for gas."));
                    return {
                      gasEstimate: baseGasUse,
                      gasCostInToken: CurrencyAmount.fromRawAmount(token, 0),
                      gasCostInUSD: CurrencyAmount.fromRawAmount(usdToken, 0)
                    };
                  }

                  var token0 = nativePool.token0.address == nativeCurrency.address; // returns mid price in terms of the native currency (the ratio of quoteToken/nativeToken)

                  var nativeTokenPrice = token0 ? nativePool.token0Price : nativePool.token1Price;
                  var gasCostInTermsOfQuoteToken;

                  try {
                    // native token is base currency
                    gasCostInTermsOfQuoteToken = nativeTokenPrice.quote(totalGasCostNativeCurrency);
                  } catch (err) {
                    log.info({
                      nativeTokenPriceBase: nativeTokenPrice.baseCurrency,
                      nativeTokenPriceQuote: nativeTokenPrice.quoteCurrency,
                      gasCostInEth: totalGasCostNativeCurrency.currency
                    }, 'Debug eth price token issue');
                    throw err;
                  } // true if token0 is the native currency


                  var token0USDPool = usdPool.token0.address == nativeCurrency.address; // gets the mid price of the pool in terms of the native token

                  var nativeTokenPriceUSDPool = token0USDPool ? usdPool.token0Price : usdPool.token1Price;
                  var gasCostInTermsOfUSD;

                  try {
                    gasCostInTermsOfUSD = nativeTokenPriceUSDPool.quote(totalGasCostNativeCurrency);
                  } catch (err) {
                    log.info({
                      usdT1: usdPool.token0.symbol,
                      usdT2: usdPool.token1.symbol,
                      gasCostInNativeToken: totalGasCostNativeCurrency.currency.symbol
                    }, 'Failed to compute USD gas price');
                    throw err;
                  }

                  return {
                    gasEstimate: baseGasUse,
                    gasCostInToken: gasCostInTermsOfQuoteToken,
                    gasCostInUSD: gasCostInTermsOfUSD
                  };
                };

                return _context2.abrupt("return", {
                  estimateGasCost: estimateGasCost.bind(this),
                  calculateL1GasFees: calculateL1GasFees
                });

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buildGasModel(_x, _x2, _x3, _x4, _x5) {
        return _buildGasModel.apply(this, arguments);
      }

      return buildGasModel;
    }()
  }, {
    key: "estimateGas",
    value: function estimateGas(routeWithValidQuote, gasPriceWei, chainId) {
      var totalInitializedTicksCrossed = BigNumber.from(Math.max(1, _.sum(routeWithValidQuote.initializedTicksCrossedList)));
      var totalHops = BigNumber.from(routeWithValidQuote.route.pools.length);
      var hopsGasUse = COST_PER_HOP(chainId).mul(totalHops);
      var tickGasUse = COST_PER_INIT_TICK(chainId).mul(totalInitializedTicksCrossed);
      var uninitializedTickGasUse = COST_PER_UNINIT_TICK.mul(0); // base estimate gas used based on chainId estimates for hops and ticks gas useage

      var baseGasUse = BASE_SWAP_COST(chainId).add(hopsGasUse).add(tickGasUse).add(uninitializedTickGasUse);
      var baseGasCostWei = gasPriceWei.mul(baseGasUse);
      var wrappedCurrency = WRAPPED_NATIVE_CURRENCY[chainId];
      var totalGasCostNativeCurrency = CurrencyAmount.fromRawAmount(wrappedCurrency, baseGasCostWei.toString());
      return {
        totalGasCostNativeCurrency: totalGasCostNativeCurrency,
        totalInitializedTicksCrossed: totalInitializedTicksCrossed,
        baseGasUse: baseGasUse
      };
    }
  }, {
    key: "getHighestLiquidityNativePool",
    value: function () {
      var _getHighestLiquidityNativePool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(chainId, token, poolProvider) {
        var nativeCurrency, nativePools, poolAccessor, pools, maxPool;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                nativeCurrency = WRAPPED_NATIVE_CURRENCY[chainId];
                nativePools = _([FeeAmount.HIGH, FeeAmount.MEDIUM, FeeAmount.LOW]).map(function (feeAmount) {
                  return [nativeCurrency, token, feeAmount];
                }).value();
                _context3.next = 4;
                return poolProvider.getPools(nativePools);

              case 4:
                poolAccessor = _context3.sent;
                pools = _([FeeAmount.HIGH, FeeAmount.MEDIUM, FeeAmount.LOW]).map(function (feeAmount) {
                  return poolAccessor.getPool(nativeCurrency, token, feeAmount);
                }).compact().value();

                if (!(pools.length == 0)) {
                  _context3.next = 9;
                  break;
                }

                log.error({
                  pools: pools
                }, "Could not find a ".concat(nativeCurrency.symbol, " pool with ").concat(token.symbol, " for computing gas costs."));
                return _context3.abrupt("return", null);

              case 9:
                maxPool = _.maxBy(pools, function (pool) {
                  return pool.liquidity;
                });
                return _context3.abrupt("return", maxPool);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getHighestLiquidityNativePool(_x7, _x8, _x9) {
        return _getHighestLiquidityNativePool.apply(this, arguments);
      }

      return getHighestLiquidityNativePool;
    }()
  }, {
    key: "getHighestLiquidityUSDPool",
    value: function () {
      var _getHighestLiquidityUSDPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(chainId, poolProvider) {
        var usdTokens, wrappedCurrency, usdPools, poolAccessor, pools, message, maxPool;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                usdTokens = usdGasTokensByChain[chainId];
                wrappedCurrency = WRAPPED_NATIVE_CURRENCY[chainId];

                if (usdTokens) {
                  _context4.next = 4;
                  break;
                }

                throw new Error("Could not find a USD token for computing gas costs on ".concat(chainId));

              case 4:
                usdPools = _([FeeAmount.HIGH, FeeAmount.MEDIUM, FeeAmount.LOW, FeeAmount.LOWEST]).flatMap(function (feeAmount) {
                  return _.map(usdTokens, function (usdToken) {
                    return [wrappedCurrency, usdToken, feeAmount];
                  });
                }).value();
                _context4.next = 7;
                return poolProvider.getPools(usdPools);

              case 7:
                poolAccessor = _context4.sent;
                pools = _([FeeAmount.HIGH, FeeAmount.MEDIUM, FeeAmount.LOW, FeeAmount.LOWEST]).flatMap(function (feeAmount) {
                  var pools = [];

                  var _iterator = _createForOfIteratorHelper(usdTokens),
                      _step;

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var _usdToken = _step.value;
                      var pool = poolAccessor.getPool(wrappedCurrency, _usdToken, feeAmount);

                      if (pool) {
                        pools.push(pool);
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  return pools;
                }).compact().value();

                if (!(pools.length == 0)) {
                  _context4.next = 13;
                  break;
                }

                message = "Could not find a USD/".concat(wrappedCurrency.symbol, " pool for computing gas costs.");
                log.error({
                  pools: pools
                }, message);
                throw new Error(message);

              case 13:
                maxPool = _.maxBy(pools, function (pool) {
                  return pool.liquidity;
                });
                return _context4.abrupt("return", maxPool);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getHighestLiquidityUSDPool(_x10, _x11) {
        return _getHighestLiquidityUSDPool.apply(this, arguments);
      }

      return getHighestLiquidityUSDPool;
    }()
    /**
     * To avoid having a call to optimism's L1 security fee contract for every route and amount combination,
     * we replicate the gas cost accounting here.
     */

  }, {
    key: "calculateOptimismToL1SecurityFee",
    value: function calculateOptimismToL1SecurityFee(routes, swapConfig, gasData) {
      var l1BaseFee = gasData.l1BaseFee,
          scalar = gasData.scalar,
          decimals = gasData.decimals,
          overhead = gasData.overhead;
      var route = routes[0];
      var inputToken = route.tradeType == TradeType.EXACT_INPUT ? route.amount.currency : route.quote.currency;
      var outputToken = route.tradeType == TradeType.EXACT_INPUT ? route.quote.currency : route.amount.currency; // build trade for swap calldata

      var trade = buildTrade(inputToken, outputToken, route.tradeType, routes);
      var data = buildSwapMethodParameters(trade, swapConfig).calldata;
      var l1GasUsed = this.getL2ToL1GasUsed(data, overhead); // l1BaseFee is L1 Gas Price on etherscan

      var l1Fee = l1GasUsed.mul(l1BaseFee);
      var unscaled = l1Fee.mul(scalar); // scaled = unscaled / (10 ** decimals)

      var scaledConversion = BigNumber.from(10).pow(decimals);
      var scaled = unscaled.div(scaledConversion);
      return [l1GasUsed, scaled];
    }
  }, {
    key: "calculateArbitrumToL1SecurityFee",
    value: function calculateArbitrumToL1SecurityFee(routes, swapConfig, gasData) {
      var perL2TxFee = gasData.perL2TxFee,
          perL1CalldataFee = gasData.perL1CalldataFee;
      var route = routes[0];
      var inputToken = route.tradeType == TradeType.EXACT_INPUT ? route.amount.currency : route.quote.currency;
      var outputToken = route.tradeType == TradeType.EXACT_INPUT ? route.quote.currency : route.amount.currency; // build trade for swap calldata

      var trade = buildTrade(inputToken, outputToken, route.tradeType, routes);
      var data = buildSwapMethodParameters(trade, swapConfig).calldata; // calculates gas amounts based on bytes of calldata, use 0 as overhead.

      var l1GasUsed = this.getL2ToL1GasUsed(data, BigNumber.from(0)); // multiply by the fee per calldata and add the flat l2 fee

      var l1Fee = l1GasUsed.mul(perL1CalldataFee);
      l1Fee = l1Fee.add(perL2TxFee);
      return [l1GasUsed, l1Fee];
    } // based on the code from the optimism OVM_GasPriceOracle contract

  }, {
    key: "getL2ToL1GasUsed",
    value: function getL2ToL1GasUsed(data, overhead) {
      // data is hex encoded
      var dataArr = data.slice(2).match(/.{1,2}/g);
      var numBytes = dataArr.length;
      var count = 0;

      for (var i = 0; i < numBytes; i += 1) {
        var byte = parseInt(dataArr[i], 16);

        if (byte == 0) {
          count += 4;
        } else {
          count += 16;
        }
      }

      var unsigned = overhead.add(count);
      var signedConversion = 68 * 16;
      return unsigned.add(signedConversion);
    }
  }]);

  return V3HeuristicGasModelFactory;
}(IV3GasModelFactory);